import { render, staticRenderFns } from "./BoardNotify.vue?vue&type=template&id=c84a0d92&lang=pug"
import script from "./BoardNotify.vue?vue&type=script&lang=js"
export * from "./BoardNotify.vue?vue&type=script&lang=js"
import style0 from "./BoardNotify.vue?vue&type=style&index=0&id=c84a0d92&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports